import { s, h } from '../lib/sx'
import { A } from '../lib/router'
import { PageHero } from '../components/PageHero'
import { copy } from '../content/copy'
import { services } from '../content/services'

export function Services() {
  return (
    <div>
      <PageHero eyebrow="Services" title={copy.services.headline} sub={copy.services.sub} />
      <section style={s('max-width:1320px;margin:0 auto;padding:0 clamp(18px,4vw,32px) 100px;')}>
        {services.map((sv) => (
          <A
            key={sv.slug}
            href={`/services/${sv.slug}`}
            style={s('display:grid;grid-template-columns:64px minmax(0,1.3fr) minmax(0,1fr) 36px;gap:clamp(14px,2vw,32px);align-items:center;padding:40px 24px;border-bottom:1px solid #DCE0E5;color:#1B2430;')}
            className={h('background:#1B2430;color:#F2F4F6;')}
          >
            <span style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.16em;color:#A8500F;")}>{sv.no}</span>
            <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(20px,2.6vw,30px);letter-spacing:-0.02em;margin:0;')}>{sv.title}</h2>
            <p style={s('font-size:15px;line-height:1.6;color:#66707C;margin:0;')}>{sv.blurb}</p>
            <span style={s('font-size:22px;text-align:right;')}>→</span>
          </A>
        ))}
      </section>
    </div>
  )
}
